export const TUULELIINID_AUTH_METHODS = ['email', 'id-kaart', 'mobiil-id', 'smart-id'] as const
export type TuuleliinidAuthMethod = (typeof TUULELIINID_AUTH_METHODS)[number]

export const ESTONIAN_AUTH_METHODS = ['id-kaart', 'mobiil-id', 'smart-id'] as const
export type EstonianAuthMethod = (typeof ESTONIAN_AUTH_METHODS)[number]

export const isEstonianMethod = (method: TuuleliinidAuthMethod): method is EstonianAuthMethod =>
  (ESTONIAN_AUTH_METHODS as readonly string[]).includes(method)

export type AuthVariant = 'signup' | 'login'

export const AUTH_HEADING_ID = 'auth-heading'

export { AUTH_ERROR_CODES } from '@/root/shared-types/api/auth'

export const PASSWORD_RULES = [
  { key: 'authPasswordRuleMinLength', test: (v: string) => v.length >= 8 },
  { key: 'authPasswordRuleUppercase', test: (v: string) => /[A-Z]/.test(v) },
  { key: 'authPasswordRuleNumber', test: (v: string) => /[0-9]/.test(v) },
  { key: 'authPasswordRuleSpecial', test: (v: string) => /[@$!%*?&]/.test(v) },
  { key: 'authPasswordRuleNoSpaces', test: (v: string) => !/\s/.test(v) },
] as const
